<template>
  <div>
    <el-dialog
      :title="(item.ID ? '编辑' : '新建') + '角色'"
      :visible="visible"
      :close-on-click-modal="false"
      @close="onClose"
      @open="onOpen"
      width="40%"
      top="5vh"
    >
      <el-form ref="itemform" :model="item" label-width="85px" :rules="rules">
        <el-form-item label="角色名称" prop="Name">
          <el-input
            v-model.trim="item.Name"
            placeholder="请输入角色名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色说明" prop="Remark">
          <el-input
            v-model.trim="item.Remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="请输入角色说明"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色权限" prop="Perms">
          <el-tree
            ref="permsTree"
            :data="permsTreeData"
            :props="defaultProps"
            :default-expand-all="true"
            show-checkbox
            node-key="key"
            @check="checkChange"
          ></el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="onClose">
          <i class="fas fa-fw fa-times" aria-hidden="true" />取 消
        </el-button>
        <el-button type="primary" :disabled="submitting" @click="onSubmit">
          <i class="far fa-fw fa-save" aria-hidden="true" />确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as _clone from "lodash/clone";

export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
    permsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      item: {},
      rules: {
        Name: [
          {
            required: true,
            message: "角色名称不能为空",
            trigger: "change, blur",
          },
        ],
        // Perms: [
        //   { required: true, message: "权限不能为空", trigger: "change, blur" },
        // ],
      },
      submitting: false,
      permsTreeData: [],
      defaultProps: {
        label: "desc",
        children: "children",
      },
      selectKeys: [],
      index: 0,
    };
  },
  methods: {
    onOpen() {
      this.item = _clone(this.value);
      this.bingTree();

      if (this.item.Perms) {
        this.$nextTick(() => {
          this.selectKeys = [];
          this.$refs.permsTree.setCheckedKeys([]);
          this.item.Perms.forEach((perms) => {
            this.selectKeys.push(perms.Obj + "&" + perms.Act);
          });
          this.$refs.permsTree.setCheckedKeys(this.selectKeys);
        });
      }
    },
    bingTree() {
      var groupList = []; //分类
      this.index = 0;
      //业务分类
      this.permsList.forEach((item) => {
        if (groupList.indexOf(item.Desc.Group) === -1) {
          //是导航的节点
          this.index += 1;
          groupList.push(item.Desc.Group);
          var firstNode = {
            key: this.index,
            code: "", //模块编码
            act: "", //动作编码
            group: item.Desc.Group, //分类名称
            model: item.Desc.Group, //模块名称
            desc: item.Desc.Group, //模块动作名称
            children: [],
          };

          var modelList = []; //模块
          this.permsList.forEach((perms) => {
            if (
              item.Desc.Group === perms.Desc.Group &&
              modelList.indexOf(perms.Desc.Model) === -1
            ) {
              //是导航的节点
              this.index += 1;
              modelList.push(perms.Desc.Model);
              var permsNode = {
                key: this.index,
                code: "", //模块编码
                act: "", //动作编码
                group: perms.Desc.Group, //分类名称
                model: perms.Desc.Model, //模块名称
                desc: perms.Desc.Model, //树节点显示，模块名称
                children: [],
              };
              firstNode.children.push(this.getChild(permsNode));
            }
          });

          this.permsTreeData.push(firstNode);
        }
      });
    },
    //绑定模块动作
    getChild(node) {
      this.permsList.forEach((perms) => {
        if (
          node.group === perms.Desc.Group &&
          node.model === perms.Desc.Model
        ) {
          this.index += 1;
          var permsNode = {
            key: perms.Path.Obj + "&" + perms.Path.Act,
            code: perms.Path.Obj,
            act: perms.Path.Act,
            group: perms.Desc.Group,
            model: perms.Desc.Model,
            desc: perms.Desc.Act, //树节点显示，模块动作名称
            children: [],
          };
          node.children.push(permsNode);
        }
      });
      return node;
    },
    checkChange(data, obj) {
      this.selectKeys = obj.checkedKeys;
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.selectKeys = [];
      this.permsTreeData = [];
      this.$refs.permsTree.setCheckedKeys([]);
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) return;
        if (this.permsList === null && this.permsList.length === 0) {
          this.$message({
            type: "warning",
            message: "权限不能为空",
            duration: 1500,
          });
          return;
        }

        this.submitting = true;
        const permsArr = [];
        this.permsList.forEach((perm) => {
          if (
            this.selectKeys.indexOf(perm.Path.Obj + "&" + perm.Path.Act) !== -1
          ) {
            permsArr.push({
              Act: perm.Path.Act,
              Obj: perm.Path.Obj,
              // Navigation: perm.Path.Navigation,
            });
          }
        });

        this.item.Perms = permsArr;
        this.$axios
          .request({
            url: this.item.ID ? `role/${this.item.ID}` : "role",
            method: this.item.ID ? "put" : "post",
            data: this.item,
          })
          .then(() => {
            this.$message.success(
              this.item.ID ? "成功编辑角色" : "成功新增角色"
            );
            this.submitting = false;
            this.$emit("form:saved", true);
            // this.$emit('update:visible', false);
            this.onClose();
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
          });
      });
    },
  },
};
</script>
